/**
 * @file: 画布更新模块
 * @author: xiaolong.huang@dmall.com
 */

import { cubeModify, forceCubeModify } from './cubeModify';
import { updateDepByCubeId } from './updateDep';
import { initMessage } from './message';
import { run, updateAllCubes } from './run';
import { updateAxisSync } from './updateAxis';
import { doneSync, doneAsync } from './done';
import { updateAllShelfsClass } from './updateAllShelfsClass';
import { updateCubeList } from './updateCubeList';
import { updateEnd } from './updateEnd';
import { layerForceLayout } from './updateLayer';
import { getCubeBeforeUpdateInfo } from './getCubeBeforeUpdateInfo';

export {
    cubeModify,
    forceCubeModify,
    updateDepByCubeId,
    initMessage,
    run,
    updateAxisSync,
    doneSync,
    doneAsync,
    updateAllCubes,
    updateAllShelfsClass,
    updateCubeList,
    updateEnd,
    layerForceLayout,
    getCubeBeforeUpdateInfo
};

export default {
    cubeModify,
    forceCubeModify,
    updateDepByCubeId,
    initMessage,
    run,
    updateAxisSync,
    doneSync,
    doneAsync,
    updateAllCubes,
    updateAllShelfsClass,
    updateCubeList,
    updateEnd,
    layerForceLayout,
    getCubeBeforeUpdateInfo
};
